module.exports = __webpack_public_path__ + "img/3_4256d9759.png";